import React, { useEffect, useState } from "react";
import { successToaster } from "../../helpers/utils";
import { baseUrl } from "/src/config/config";

const LogosModal = ({ setIsOpen, ImgType }) => {
	const [ActiveImgType, setActiveImgType] = useState(".svg");

	const notify = () => successToaster("Copied to Clipboard");

	const [EmbedData, setEmbedData] = useState({});

	useEffect(() => {
		switch (ImgType) {
			case "konfpurple":
				setEmbedData({
					Img: `${baseUrl}/logos/konfhub-logo-purple${ActiveImgType}`,
					Html: `<img src="${baseUrl}/logos/konfhub-logo-purple${ActiveImgType}" alt="Konfhub Logo (Purple).">`,
					Markdown: `![Konfhub Logo (Purple)](${baseUrl}/logos/konfhub-logo-purple${ActiveImgType})`
				});
				break;

			case "konfwhite":
				setEmbedData({
					Img: `${baseUrl}/logos/konfhub-logo-white${ActiveImgType}`,
					Html: `<img src="${baseUrl}/logos/konfhub-logo-white${ActiveImgType}" alt="Konfhub Logo (White).">`,
					Markdown: `![Konfhub Logo (White)](${baseUrl}/logos/konfhub-logo-white${ActiveImgType})`
				});
				break;

			case "poweredkonfpurple":
				setEmbedData({
					Img: `${baseUrl}/logos/Powered-konfhub-logo-purple${ActiveImgType}`,
					Html: `<img src="${baseUrl}/logos/Powered-konfhub-logo-purple${ActiveImgType}" alt="Powered By Konfhub Logo (Purple).">`,
					Markdown: `![Powered By Konfhub Logo (Purple)](${baseUrl}/logos/Powered-konfhub-logo-purple${ActiveImgType})`
				});
				break;

			case "poweredkonfwhite":
				setEmbedData({
					Img: `${baseUrl}/logos/Powered-konfhub-logo-white${ActiveImgType}`,
					Html: `<img src="${baseUrl}/logos/Powered-konfhub-logo-white${ActiveImgType}" alt="Powered By Konfhub Logo (White).">`,
					Markdown: `![Powered By Konfhub Logo (White)](${baseUrl}/logos/Powered-konfhub-logo-white${ActiveImgType})`
				});
				break;
			case "konfshortpurple":
				setEmbedData({
					Img: `${baseUrl}/logos/konfhub-icon-purple${ActiveImgType}`,
					Html: `<img src="${baseUrl}/logos/konfhub-icon-purple${ActiveImgType}" alt="Konfhub Icon (Purple).">`,
					Markdown: `![Konfhub Icon (Purple)](${baseUrl}/logos/konfhub-icon-purple${ActiveImgType})`
				});
				break;
			case "konfshortwhite":
				setEmbedData({
					Img: `${baseUrl}/logos/konfhub-icon-white${ActiveImgType}`,
					Html: `<img src="${baseUrl}/logos/konfhub-icon-white${ActiveImgType}" alt="Konfhub Icon (White).">`,
					Markdown: `![Konfhub Icon (White)](${baseUrl}/logos/konfhub-icon-white${ActiveImgType})`
				});
			case "konfoctopus":
				setEmbedData({
					Img: `${baseUrl}/logos/konfhub-octopus${ActiveImgType}`,
					Html: `<img src="${baseUrl}/logos/konfhub-octopus${ActiveImgType}" alt="Konfhub Icon (White).">`,
					Markdown: `![Konfhub Octopus](${baseUrl}/logos/konfhub-octopus${ActiveImgType})`
				});
				break;
		}
	}, [ImgType, ActiveImgType]);

	return (
		<>
			<div className="logos-card">
				<div className="">
					<div className="svg-div">
						<h5>Embed</h5>
						<svg
							viewBox="0 0 24 24"
							onClick={() => setIsOpen(false)}
							className="wt-icon"
						>
							<path d="M19.707 5.707l-1.414-1.414L12 10.586 5.707 4.293 4.293 5.707 10.586 12l-6.293 6.293 1.414 1.414L12 13.414l6.293 6.293 1.414-1.414L13.414 12l6.293-6.293z"></path>
						</svg>
					</div>
				</div>
				<div>
					<div className="btns-div">
						<a
							className={ActiveImgType === ".svg" ? "btn active" : "btn"}
							onClick={() => setActiveImgType(".svg")}
						>
							SVG
						</a>
						<a
							className={ActiveImgType === ".png" ? "btn active" : "btn"}
							onClick={() => setActiveImgType(".png")}
						>
							PNG
						</a>
					</div>
				</div>
				<div className="embed-block blk1">
					<h6>Image URL</h6>
					<div className="embed-code">
						<div className="copy-btn">
							<div className="copy-btn-block">
								<svg
									viewBox="0 0 24 24"
									onClick={() => {
										navigator.clipboard.writeText(EmbedData.Img);
										notify();
									}}
									className="wt-icon2"
								>
									<path d="M9 5h10v10H9z"></path>
									<path d="M7 9H5v10h10v-2H7V9z"></path>
								</svg>
							</div>
						</div>
						<p>{EmbedData.Img}</p>
					</div>
				</div>
				<div className="embed-block mt-4">
					<h6>HTML</h6>
					<div className="embed-code">
						<div className="copy-btn">
							<div className="copy-btn-block">
								<svg
									viewBox="0 0 24 24"
									onClick={() => {
										navigator.clipboard.writeText(EmbedData.Html);
										notify();
									}}
									className="wt-icon2"
								>
									<path d="M9 5h10v10H9z"></path>
									<path d="M7 9H5v10h10v-2H7V9z"></path>
								</svg>
							</div>
						</div>
						<span>{EmbedData.Html}</span>
					</div>
				</div>
				<div className="embed-block mt-4">
					<h6>Markdown</h6>
					<div className="embed-code">
						<div className="copy-btn">
							<div className="copy-btn-block">
								<svg
									viewBox="0 0 24 24"
									onClick={() => {
										navigator.clipboard.writeText(EmbedData.Markdown);
										notify();
									}}
									className="wt-icon2"
								>
									<path d="M9 5h10v10H9z"></path>
									<path d="M7 9H5v10h10v-2H7V9z"></path>
								</svg>
							</div>
						</div>
						<p>{EmbedData.Markdown}</p>
					</div>
				</div>
			</div>
			<style jsx>
				{`
					.logos-card {
						min-width: 32px;
						max-width: 520px;
						min-height: 32px;
						max-height: 80vh;
						overflow-y: auto;
					}
					.wt-icon {
						width: 24px !important;
						height: 24px !important;
						min-width: 24px !important;
						min-height: 24px !important;
						float: right !important;
						margin-top: -30px;
						cursor: pointer;
					}
					.active {
						border: 2px solid black !important;
					}
					.wt-icon2 {
						width: 24px !important;
						height: 24px !important;
						min-width: 24px !important;
						min-height: 24px !important;
						float: right !important;
						cursor: pointer;
					}
					.btns-div {
						float: right !important;
						margin-top: 22px;
					}
					.btns-div a {
						font-size: 13px;
						border: 2px solid white;
					}
					.embed-block {
						// margin-top: 75px;
					}
					.embed-code {
						position: relative;
						margin-top: 8px;
						padding: 16px 10px 16px 16px;
						word-break: break-all;
						background: #f4f4f4;
					}
					p {
						font-size: 15px;
					}
					.blk1 {
						margin-top: 70px;
					}
				`}
			</style>
		</>
	);
};

export default LogosModal;
